function closeCurrentPage () {
  if (window.WeixinJSBridge && typeof window.WeixinJSBridge.call === 'function') {
    window.WeixinJSBridge.call('closeWindow')
    return
  }

  if (window.AlipayJSBridge && typeof window.AlipayJSBridge.call === 'function') {
    window.AlipayJSBridge.call('closeWebview')
    return
  }

  window.close()

  setTimeout(() => {
    if (!document.hidden && window.history.length > 1) {
      window.history.back()
    }
  }, 180)
}

function finishSuccess (returnUrl, message = '支付成功！') {
  if (returnUrl) {
    window.location.href = returnUrl
    return
  }

  window.alert(`${message}\n页面即将关闭`)
  closeCurrentPage()
}

export { closeCurrentPage, finishSuccess }
